export enum CreateFormKeys {
    Name = 'name',
    Code = 'code',
    Disk = 'disk',
    Path = 'path',
    Sort = 'sort',
    Auth = 'auth',
    UploadedFile = 'uploaded-file',
}
